"use strict";
// (C) 2020-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
function tryFocus(handler) {
    return createInterval(function () { return isVisible(handler()); }, function () { return handler().focus(); });
}
exports.default = tryFocus;
function createInterval(check, done) {
    var timer = window.setInterval(function () {
        if (check()) {
            done();
            window.clearInterval(timer);
        }
    }, 25);
    return timer;
}
function isVisible(element) {
    if (element) {
        var style = window.getComputedStyle(element);
        var notHidden = style.visibility !== "hidden";
        var notNone = style.display !== "none";
        var hasSize = element.offsetHeight > 0;
        return notHidden && notNone && hasSize;
    }
    return false;
}
//# sourceMappingURL=focus.js.map